import { full, FullProps, sx, SxProps } from '@/atoms/System/styledUtils'
import { StyledDivProps } from '@/atoms/System/types'
import styled from '@/styles'

/**
 * @deprecated Use MUI
 */
export type BoxProps = StyledDivProps & FullProps & SxProps

/**
 * @deprecated Use MUI
 * The MUI Box is super slow for some reason (takes up to 5ms to render).
 * This code is almost the same, but uses `styled` from `styled-components` and avoids
 * a couple of additional MUI CSS wrappers. As a result is works at least 5x faster.
 */
export const Box = styled.div<BoxProps>`
	${full}
	${sx}
`

Box.displayName = 'Box'
